/**
 * @generated SignedSource<<6494bb928dd602ad1ad5b665b498ad8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckHasLiveTagArticle$data = {
  readonly flattenTypeIds: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly liveArticle: {
    readonly status: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "helpersCheckHasLiveTagArticle";
};
export type helpersCheckHasLiveTagArticle$key = {
  readonly " $data"?: helpersCheckHasLiveTagArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckHasLiveTagArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckHasLiveTagArticle"
};

(node as any).hash = "f5b96a99fccb22568477ef81766f8fc3";

export default node;
